module.exports = ".pl-1 {\n  padding-left: 1rem !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/utilitarios-management/users-instance-procedure/users-instance-procedure.component.scss
// module id = ./src/app/administration/utilitarios-management/users-instance-procedure/users-instance-procedure.component.scss
// module chunks = main